// extracted by mini-css-extract-plugin
module.exports = {"short_input":"short_input--I8a_h","large_input":"large_input--1udgl","text_area":"text_area--1ECoe"};